import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  loadAutoUpdatePaymentRequested,
  loadBillInfoRequested,
  loadPaymentBillRequested,
  storeAutoUpdatePaymentRequested,
  storePaymentRequested,
  loadBillInfoByDateRequested,
} from "store/payments/paymentSlice";

export function useStorePayment() {
  const dispatch = useDispatch();

  const onStorePayment = useCallback(
    async (values: any) => {
      values.paymentType = values.paymentType?.id;
      await dispatch(storePaymentRequested(values));
    },
    [dispatch]
  );
  return { onStorePayment };
}

export function useLoadPaymentBill(reference: any) {
  const dispatch = useDispatch();

  const onLoadPaymentBill = useCallback(async () => {
    await dispatch(loadPaymentBillRequested(reference));
  }, [dispatch, reference]);

  useEffect(() => {
    onLoadPaymentBill();
  }, [onLoadPaymentBill]);

  return { onLoadPaymentBill };
}

export function useLoadBillInfo(reference: string) {
  const dispatch = useDispatch();

  const onLoadBillInfo = useCallback(async () => {
    await dispatch(loadBillInfoRequested(reference));
  }, [dispatch]);

  useEffect(() => {
    onLoadBillInfo();
  }, [onLoadBillInfo, reference]);
  return { onLoadBillInfo };
}

export function useStoreAutoUpdatePayment() {
  const dispatch = useDispatch();

  const onStoreAutoUpdatePayment = useCallback(async () => {
    await dispatch(storeAutoUpdatePaymentRequested({}));
  }, [dispatch]);
  return { onStoreAutoUpdatePayment };
}

export function useLoadAutoUpdatePayment() {
  const dispatch = useDispatch();
  const onLoadAutoUpdatePayment = useCallback(async () => {
    await dispatch(loadAutoUpdatePaymentRequested({}));
  }, [dispatch]);

  useEffect(() => {
    onLoadAutoUpdatePayment();
  }, [onLoadAutoUpdatePayment]);
  return { onLoadAutoUpdatePayment };
}

export function useLoadBillInfoByDate(reference: string, date: any) {
  const dispatch = useDispatch();

  const onLoadBillInfoByDate = useCallback(async () => {
    await dispatch(
      loadBillInfoByDateRequested({ reference: reference, date: date })
    );
  }, [dispatch, reference, date]);

  useEffect(() => {
    onLoadBillInfoByDate();
  }, [onLoadBillInfoByDate]);
  return { onLoadBillInfoByDate };
}
